// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
import { Field } from 'react-final-form';
import { contactUpdateFormFields } from './UpdateContactFormInitData';

const UpdateContactChildForm = () => (
  <div className="flex margin-2-b">
    <Field {...contactUpdateFormFields.contactName} />
    <Field {...contactUpdateFormFields.emailAddress} disabled={true} />
    <Field {...contactUpdateFormFields.role} disabled={true} />
  </div>
  );

UpdateContactChildForm.displayName = 'UpdateContactChildForm';

UpdateContactChildForm.propTypes = {
  dialCodes: PropTypes.arrayOf(PropTypes.shape({})),
};

export default UpdateContactChildForm;
